/* eslint-disable */

export const getVendorParam = state => state.environment.VENDOR;

export const getDestinationURLParam = (state) => {
  return state.routing.locationBeforeTransitions.query.destinationURL ? decodeURIComponent(state.routing.locationBeforeTransitions.query.destinationURL) : false;
};

export const getReferrerURLParam = (state) => {
  return state.routing.locationBeforeTransitions.query.referrerURL ? decodeURIComponent(state.routing.locationBeforeTransitions.query.referrerURL) : false;
};

export const getEIMCode = state => state.routing.locationBeforeTransitions.query.eimCode || false;

export const isConfigPage = (state) => {
  return getVendorParam(state) && (getDestinationURLParam(state) || getReferrerURLParam(state));
}

export const isRangePage = (state) => {
  return state.routing.locationBeforeTransitions.query.range || false;
}

export const eimCodeError = state => state.routing.locationBeforeTransitions.query.error || false;

export const getTotalPrice = (paymentOption) => {
  return paymentOption.useTotalPrice ? paymentOption.totalPrice : paymentOption.useTotalPrice;
}

// const extractHostName = (url) => {
//   if (url) {
//     const link = document.createElement('a');
//     link.setAttribute('href', url);
//     return `${link.protocol}//${link.hostname}`;
//   }
//   return false
// };

export const getHeliosZip = (state) => {
  return state.routing.locationBeforeTransitions.query.zipCode || false;
}

// Need to identify if this is a trim that does not exist in legacy cms as a trim
export const isConstructedTrim = (state) => {
  const urlBool = state.routing.locationBeforeTransitions.query.vehicleTrimConstructed;
  return urlBool === 'true';
}

// If Trim does not exist in Legacy CMS we need to pull ot the Ncode from the URL
export const getURLNCode = (state) => {
  const path = state.routing.locationBeforeTransitions.pathname;
  const split = path.split('/');
  return split[split.length - 1];
}

// Selector to pull in Trim name if it does not exist in our legacy CMS
export const getURLTrimName = (state) => {
  return state.routing.locationBeforeTransitions.query.trimName || false;
}

/* eslint-enable */




/** WEBPACK FOOTER **
 ** ./src/redux/selectors/helios.js
 **/